var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_391_839",
    transform: "translate(0 0.09375) scale(0.0104167 0.00846354)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_391_839",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADBklEQVR4nO3dPWtUQRTG8b8vGJUgSCwUMUQLmxhFP4MpFBs7sbCJpQiCjeBnMIoxovhS5QOIYKFGwUqwjQiiCOlE05htXFxiMQlisbv3nN3Zk537/GCKwMzdc+chs3fv3kxARERERERERESkuingDrAENIC1wltj/VxvA8f6MH9uI8A80CJ+UqJaC7gH7OhxLs1GgDc9FF5aW2TAIdzPcBLD3uZ6mlGDKeq97LRrf4BJ62RutQ4ALjvHlW4bMGMd5JnI044xdTFtHbDF8SKrwKhjXB2sAnssAzwBrDnG1IlpTrWWB9seXUCwVWCF9Aa6sayOALsHVUCdAvgOvCB9gHy3/vPvNn13AWPAPuAU8HgQBVYVfb1tbcvAFdKkekwaX8+k9N+AZ8Al4Fd0Ie2U/CZ8EzjPJp58r+glpUp72sfzzboEeURPbrf2gf7emcwaQIlL0A2gGV1EVaUF8B54HV2ERWkBPIwuwKq0AN5GFzAI0W+y7dpnx7kcJ10xfSFdrvajDpOSPoh9MvafBp6T7v2EKWkJWjH2nyN48qGsAH4a+h4EjuYqxKKkACy3HA5kq8KopAAsxqIL2FDXADxfxWZR1wA2DQUQTAEEUwDBFECwYXkw6yLwo0ufr8C3iscbA05W7DsDXKjYFwZwhRVxo+1Q7pPqYKFDXfpGbAAmch5cAXR3OOfBFUBnO4H9OV9AAXQ2QeY3VQXQWdblBxRANwogmAIIpgCCZQ9gWG5FLJP+DreTW6RtA6o4R9rfoptx7E+OmOZ0WB5LGa/QZ6/heKPAEWctfaUlKJgCCKYAgimAYAogmAIIpgCCKYBgCiCYAgimAIIpgGAKIJgCCKYAgimAYAogmAII5gmg0fcqymHencsTwLJjTF2Y58YTwCvHmLp4aR3gCeARaft6+V8LeGId5AlgCXjgGFe6eeCjdZD3KugaaQdaSRaB656B3gCawBnSk2h1Xo5awF3gLM6NAnv5HNAkbQl8Apjl37+xKt3Gv7GaJZ37VYZol0YREREREREREYnzF+sBkMTb3P1sAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.30cc92b59ce6cdb1adad841761c49351.svg";
export { ForwardRef as ReactComponent };